// Module
var code = "<select class=\"form-control\" ng-model=\"data.currentRoute\" ng-options=\"option.id as option.name for option in data.routes\" id=\"routeSelector\"> <option value=\"\">{{ data.routes.length > 0 ? '-- Choisir l\\'itinéraire --' : '--' }}</option> </select> ";
// Exports
export default code;